import { useEffect } from "react";
import {
  capitalizeFLetter,
  getLocalStorage,
} from "features/components/helperFunctions";
import { initializeApp } from "firebase/app";

import {
  getFirestore,
  collection,
  addDoc,
  getDocs,
  doc,
  setDoc,
  query,
  where,
  orderBy,
  limit,
} from "firebase/firestore";
import { FIREBASE_APP } from "utils/constants";
import { dispatch, useSelector } from "store";
import moment from "moment";
import { setActivityLogs } from "store/slices/Firebase";
import { FIREBASE_REMOTE_CONFIG_KEY } from "config";
import { openSnackbar } from "store/slices/snackbar";

export let logDataChange: (data: any) => void;

export let getDataFromFirestore: () => any;

let db: any = "";

const FireStoreConfig = () => {
  const { businessAllBranches } = useSelector(
    (state) => state.businessBranches
  );
  const { selectedBranch } = useSelector((reduxState) => reduxState.dropdown);

  const { eatout_id, eatout_name, branch_name, user_id, eatout_username } =
    getLocalStorage();

  useEffect(() => {
    const app = initializeApp(FIREBASE_APP);
    db = getFirestore(app);
  }, []);

  logDataChange = async function (data: any) {
    if (FIREBASE_REMOTE_CONFIG_KEY === "live") {
      try {
        const timestamp = moment().utc().format("YYYY-MM-DDTHH:mm:ss");

        const docRef = doc(db, `ACTIVITY_LOGS/${timestamp}`);
        const loggedIn = localStorage.getItem("tdLogin");

        const getLoggedInDetails = () => {
          if (loggedIn) {
            return {
              branchId:
                businessAllBranches?.length > 1 ? "" : `${selectedBranch}`,
              username: capitalizeFLetter(`${eatout_username}`),
              userId: `${user_id}`,
              branch_name: `${branch_name}`,
              business_id: `${eatout_id}`,
              business_name: `${eatout_name}`,
            };
          } else {
            return {};
          }
        };

        await setDoc(docRef, {
          createdAt: timestamp,
          ...getLoggedInDetails(),
          ...data,
        });
      } catch (e) {
        dispatch(
          openSnackbar({
            open: true,
            message: "Logging Data Failed",
            alert: { color: "error" },
          })
        );
      }
    }
  };

  getDataFromFirestore = async function () {
    if (FIREBASE_REMOTE_CONFIG_KEY === "live") {
      try {
        // Query the collection for documents with a specific business ID
        const querySnapshot = await getDocs(
          query(
            collection(db, "ACTIVITY_LOGS"),
            where("business_id", "==", `${eatout_id}`),
            orderBy("createdAt", "desc"),
            limit(100)
          )
        );

        // Check if any documents match the query
        if (!querySnapshot.empty) {
          // Extract the first document from the query result
          const formattedData = querySnapshot.docs.map((doc) => {
            return {
              createdAt: moment(doc.data().createdAt).format(
                "MMMM Do YYYY, h:mm:ss a"
              ),
              userId: doc.data().userId,
              username: doc.data().username,
              branch_name: doc.data().branch_name,
              branchId: doc.data().branchId,
              message: doc.data().message,
              endpoint: doc.data().action.url,
              payload: JSON.stringify(doc.data().action.payload),
              response: JSON.stringify(doc.data().action.response),
              method: doc.data().action.method,
            };
          });

          dispatch(setActivityLogs(formattedData));

          return formattedData;
        } else {
          return [];
        }
      } catch (error) {
        dispatch(setActivityLogs([]));
        dispatch(
          openSnackbar({
            open: true,
            message: "Getting Logs Failed",
            alert: { color: "error" },
          })
        );
        return [];
      }
    }
  };

  return <></>;
};
export default FireStoreConfig;
